import MarketAccountTypeComponent from './MarketAccountTypeContainer';

export default MarketAccountTypeComponent;
